import React from 'react';
//import ReactNative from 'react-native-web';
import { Text } from 'react-native-web';
import PropTypes from 'prop-types';

import TextExtraction from './TextExtraction';
import './ParsedText.css';

const PATTERNS = {
  //eslint-disable-next-line
  url: /(https?:\/\/|www\.)[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&\/\/=]*)/i,
  //eslint-disable-next-line
  phone: /[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}/,
  email: /\S+@\S+\.\S+/
};

const defaultParseShape = PropTypes.shape({
  //eslint-disable-next-line
  ...Text.propTypes,
  type: PropTypes.oneOf(Object.keys(PATTERNS)).isRequired
});

const customParseShape = PropTypes.shape({
  //eslint-disable-next-line
  ...Text.propTypes,
  pattern: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(RegExp)]).isRequired
});

class ParsedText extends React.Component {
  static displayName = 'ParsedText';

  static propTypes = {
    ...Text.propTypes,
    parse: PropTypes.arrayOf(PropTypes.oneOfType([defaultParseShape, customParseShape])),
    childrenProps: PropTypes.shape(Text.propTypes)
  };

  static defaultProps = {
    parse: null
  };

  setNativeProps(nativeProps) {
    this._root.setNativeProps(nativeProps);
  }

  getPatterns() {
    return this.props.parse.map((option) => {
      const { type, ...patternOption } = option;
      if (type) {
        if (!PATTERNS[type]) {
          throw new Error(`${option.type} is not a supported type`);
        }
        patternOption.pattern = PATTERNS[type];
      }

      return patternOption;
    });
  }

  getParsedText() {
    if (!this.props.parse) {
      return this.props.children;
    }
    if (typeof this.props.children !== 'string') {
      return this.props.children;
    }

    const textExtraction = new TextExtraction(this.props.children, this.getPatterns());
    const childrenProps = this.props.childrenProps || {};
    const props = { ...this.props };
    delete props.childrenProps;
    return textExtraction
      .parse()
      .map((props, index) => <Text key={`parsedText-${index}`} {...childrenProps} {...props} />);
  }

  render() {
    const props = { ...this.props };
    delete props.childrenProps;
    delete props.playingAudioId;
    delete props.position;
    const isAudioMessage = !!this.props.currentMessage.audio;
    // Normalize IDs for comparison (convert string to number if possible)
    const normalizeId = (id) => {
      if (id === null || id === undefined) {
        return id;
      }
      if (typeof id === 'string') {
        const num = parseInt(id, 10);
        return isNaN(num) ? id : num;
      }
      return id;
    };
    const normalizedPlayingId = normalizeId(this.props.playingAudioId);
    const normalizedMessageId = normalizeId(this.props.currentMessage.id);
    const isPlaying =
      isAudioMessage &&
      normalizedPlayingId !== null &&
      normalizedMessageId !== null &&
      normalizedPlayingId === normalizedMessageId;
    const iconId = `audio-icon-${this.props.currentMessage.id}`;

    // 音频消息图标样式：添加按钮效果
    const baseIconStyle = this.props.currentMessage.icon ? { ...this.props.currentMessage.icon.style } : {};
    const iconStyle = {
      ...baseIconStyle,
      // Themeable monochrome icons (see --idigest-chat-icon-filter)
      filter: 'var(--idigest-chat-icon-filter, brightness(0))',
      color: 'var(--idigest-chat-fg, #000000)',
      ...(isAudioMessage && {
        cursor: 'pointer',
        userSelect: 'none',
        transition: 'opacity 0.2s ease'
      })
    };

    return (
      <Text ref={(ref) => (this._root = ref)} {...props}>
        {this.getParsedText()}
        {this.props.currentMessage.icon && (
          <span
            style={{
              position: 'relative',
              display: 'inline-block',
              verticalAlign: 'middle',
              marginLeft: '4px'
            }}
          >
            <img
              id={iconId}
              src={this.props.currentMessage.icon.image}
              style={{
                ...iconStyle,
                position: 'relative',
                display: 'block'
              }}
              className={isPlaying ? 'audio-playing-icon' : ''}
            />
          </span>
        )}
      </Text>
    );
  }
}

export default ParsedText;
